// @generated by protoc-gen-es v2.10.0 with parameter "target=ts"
// @generated from file quanterix/simoa_one/analysis_app_api/v1/analyze_experiment_request.proto (package quanterix.simoa_one.analysis_app_api.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { ExperimentParameterOverrides } from "./experiment_parameter_overrides_pb";
import { file_quanterix_simoa_one_analysis_app_api_v1_experiment_parameter_overrides } from "./experiment_parameter_overrides_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file quanterix/simoa_one/analysis_app_api/v1/analyze_experiment_request.proto.
 */
export const file_quanterix_simoa_one_analysis_app_api_v1_analyze_experiment_request: GenFile = /*@__PURE__*/
  fileDesc("CkhxdWFudGVyaXgvc2ltb2Ffb25lL2FuYWx5c2lzX2FwcF9hcGkvdjEvYW5hbHl6ZV9leHBlcmltZW50X3JlcXVlc3QucHJvdG8SJ3F1YW50ZXJpeC5zaW1vYV9vbmUuYW5hbHlzaXNfYXBwX2FwaS52MSLJAQoYQW5hbHl6ZUV4cGVyaW1lbnRSZXF1ZXN0EhoKDWV4cGVyaW1lbnRfaWQYASABKAlIAIgBARJnChNwYXJhbWV0ZXJfb3ZlcnJpZGVzGAIgASgLMkUucXVhbnRlcml4LnNpbW9hX29uZS5hbmFseXNpc19hcHBfYXBpLnYxLkV4cGVyaW1lbnRQYXJhbWV0ZXJPdmVycmlkZXNIAYgBAUIQCg5fZXhwZXJpbWVudF9pZEIWChRfcGFyYW1ldGVyX292ZXJyaWRlc2IGcHJvdG8z", [file_quanterix_simoa_one_analysis_app_api_v1_experiment_parameter_overrides]);

/**
 * Rpc request to trigger analysis for an experiment
 *
 * @generated from message quanterix.simoa_one.analysis_app_api.v1.AnalyzeExperimentRequest
 */
export type AnalyzeExperimentRequest = Message<"quanterix.simoa_one.analysis_app_api.v1.AnalyzeExperimentRequest"> & {
  /**
   * Unique id (UUID) of the experiment to analyze
   *
   * @generated from field: optional string experiment_id = 1;
   */
  experimentId?: string;

  /**
   * If provided, experiment-context parameters to override from the default
   * values.
   *
   * @generated from field: optional quanterix.simoa_one.analysis_app_api.v1.ExperimentParameterOverrides parameter_overrides = 2;
   */
  parameterOverrides?: ExperimentParameterOverrides;
};

/**
 * Describes the message quanterix.simoa_one.analysis_app_api.v1.AnalyzeExperimentRequest.
 * Use `create(AnalyzeExperimentRequestSchema)` to create a new message.
 */
export const AnalyzeExperimentRequestSchema: GenMessage<AnalyzeExperimentRequest> = /*@__PURE__*/
  messageDesc(file_quanterix_simoa_one_analysis_app_api_v1_analyze_experiment_request, 0);

